export const TargetEnum = Object.freeze({
	EXTENSION: "extension",
	DASHBOARD: "dashboard"
});
